// src/components/StaffProfile.tsx
import React, { useEffect } from 'react';
import styles from '../styles/StaffProfile.module.css';
import VCImage from "../resources/OIP.jpg";

const StaffProfile = () => {
  // Scroll to section when component mounts
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const sectionId = hash.replace('#', '');
      const element = document.getElementById(sectionId);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, []);

  return (
    <div className={styles['staff-profile']}>
      {/* Header */}
      <header className={styles['profile-header']}>
        <div className={styles['header-content']}>
          <div className={styles['university-banner']}>
            <div className={styles['university-logo']}>UC</div>
            <h1>University of Calabar</h1>
          </div>
          
          <div className={styles['profile-overview']}>
            <div className={styles['profile-image-container']}>
              <img src={VCImage} alt="Dr. Chike Anya" className={styles['profile-image']} />
              <div className={styles['profile-badge']}>Professor</div>
            </div>
            
            <div className={styles['profile-info']}>
              <h1>Dr. Chike Anya, Ph.D.</h1>
              <h2>Associate Professor</h2>
              <h3>African Philosophy, Ethics, and Epistemology</h3>
              
              <div className={styles['profile-stats']}>
                <div className={styles['stat-item']}>
                  <div className={styles['stat-value']}>12</div>
                  <div className={styles['stat-label']}>Publications</div>
                </div>
                <div className={styles['stat-item']}>
                  <div className={styles['stat-value']}>48</div>
                  <div className={styles['stat-label']}>H-index</div>
                </div>
                <div className={styles['stat-item']}>
                  <div className={styles['stat-value']}>857</div>
                  <div className={styles['stat-label']}>Citations</div>
                </div>
              </div>
              
              <div className={styles['contact-info']}>
                <div className={styles['contact-item']}>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M1.5 8.67v8.58a3 3 0 003 3h15a3 3 0 003-3V8.67l-8.928 5.493a3 3 0 01-3.144 0L1.5 8.67z" />
                    <path d="M22.5 6.908V6.75a3 3 0 00-3-3h-15a3 3 0 00-3 3v.158l9.714 5.978a1.5 1.5 0 001.572 0L22.5 6.908z" />
                  </svg>
                  <span>chike.anya@unical.edu.ng</span>
                </div>
                <button className={styles['contact-btn']}>Contact Dr. Anya</button>
              </div>
            </div>
          </div>
          
          <div className={styles['profile-tagline']}>
            <p>Bridging ancient wisdom with contemporary thought in African philosophical traditions.</p>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className={styles['profile-container']}>
        <div className={styles['profile-content']}>
          {/* Left Column - About & Research */}
          <div className={styles['profile-column']}>
            {/* About Section */}
            <section id="about" className={styles['about-section']}>
              <h2 className={styles['section-title']}>About</h2>
              <div className={styles['section-content']}>
                <p>Dr. Chike Anya is an Associate Professor in the Department of Philosophy at the University of Calabar. His research focuses on integrating traditional African philosophical concepts with contemporary ethical frameworks.</p>
                
                <div className={styles['about-details']}>
                  <div className={styles['detail-item']}>
                    <span>Research Group:</span>
                    <span>African Thought & Development Initiative</span>
                  </div>
                  <div className={styles['detail-item']}>
                    <span>Office:</span>
                    <span>Humanities Building, Room 305</span>
                  </div>
                  <div className={styles['detail-item']}>
                    <span>Office Hours:</span>
                    <span>Mon & Wed, 2-4 PM</span>
                  </div>
                </div>
              </div>
            </section>
            
            {/* Research Interests */}
            <section id="research-interests" className={styles['research-section']}>
              <h2 className={styles['section-title']}>Research Interests</h2>
              <div className={styles['interests-grid']}>
                <div className={styles['interest-card']}>
                  <div className={styles['interest-icon']}>🌍</div>
                  <h3>African Ethics</h3>
                </div>
                <div className={styles['interest-card']}>
                  <div className={styles['interest-icon']}>📜</div>
                  <h3>Postcolonial Philosophy</h3>
                </div>
                <div className={styles['interest-card']}>
                  <div className={styles['interest-icon']}>🧠</div>
                  <h3>Logic</h3>
                </div>
                <div className={styles['interest-card']}>
                  <div className={styles['interest-icon']}>♀️</div>
                  <h3>Feminist Philosophy</h3>
                </div>
                <div className={styles['interest-card']}>
                  <div className={styles['interest-icon']}>⚖️</div>
                  <h3>Applied Ethics</h3>
                </div>
              </div>
            </section>
            
            {/* Supervised Students */}
            <section id="supervised-students" className={styles['students-section']}>
              <h2 className={styles['section-title']}>Supervised PhD Students</h2>
              <div className={styles['students-grid']}>
                <div className={styles['student-card']}>
                  <div className={styles['student-avatar']}>G</div>
                  <div className={styles['student-info']}>
                    <h3>Grace Okoro</h3>
                    <p>Ph.D. in African Philosophy</p>
                    <span className={`${styles['status']} ${styles['completed']}`}>Completed</span>
                  </div>
                </div>
                <div className={styles['student-card']}>
                  <div className={styles['student-avatar']}>N</div>
                  <div className={styles['student-info']}>
                    <h3>Nanard Okafor</h3>
                    <p>Ph.D. in Ethics</p>
                    <span className={`${styles['status']} ${styles['completed']}`}>Completed</span>
                  </div>
                </div>
                <div className={styles['student-card']}>
                  <div className={styles['student-avatar']}>F</div>
                  <div className={styles['student-info']}>
                    <h3>Fatima Belo</h3>
                    <p>Ph.D. in Feminist Philosophy</p>
                    <span className={`${styles['status']} ${styles['candidate']}`}>Candidate</span>
                  </div>
                </div>
              </div>
            </section>
          </div>
          
          {/* Right Column - Publications */}
          <div className={styles['profile-column']}>
            {/* Featured Publications */}
            <section id="featured-publications" className={styles['publications-section']}>
              <div className={styles['section-header']}>
                <h2 className={styles['section-title']}>Featured Publications</h2>
              </div>
              
              <div className={styles['publications-grid']}>
                <div className={styles['publication-card']}>
                  <div className={styles['pub-image']} style={{ backgroundImage: "url('https://images.unsplash.com/photo-1495640388908-05fa85288e61?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80')" }}></div>
                  <div className={styles['pub-content']}>
                    <div className={styles['pub-type']}>Book</div>
                    <h3>The Concept of Ubuntu in Modern African Ethics</h3>
                    <p>This article explores the enduring relevance of Ubuntu philosophy in shaping contemporary ethical frameworks.</p>
                    <div className={styles['pub-meta']}>
                      <span>Journal of African Philosophy</span>
                      <span>2023</span>
                    </div>
                    <a href="#" className={styles['read-more']}>Read Full Article →</a>
                  </div>
                </div>
                
                <div className={styles['publication-card']}>
                  <div className={styles['pub-image']} style={{ backgroundImage: "url('https://images.unsplash.com/photo-1506880018603-83d5b814b5a6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80')" }}></div>
                  <div className={styles['pub-content']}>
                    <div className={styles['pub-type']}>Journal Article</div>
                    <h3>Epidemiological Challenges in Oral Traditions</h3>
                    <p>Examining challenges in knowledge transfer within African oral traditions and their implications.</p>
                    <div className={styles['pub-meta']}>
                      <span>Philosophy Today</span>
                      <span>2022</span>
                    </div>
                    <a href="#" className={styles['read-more']}>Read Full Article →</a>
                  </div>
                </div>
                
                <div className={styles['publication-card']}>
                  <div className={styles['pub-image']} style={{ backgroundImage: "url('https://images.unsplash.com/photo-1677442135133-33d364e0d0c3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80')" }}></div>
                  <div className={styles['pub-content']}>
                    <div className={styles['pub-type']}>Research Paper</div>
                    <h3>Ethical Dilemmas in AI Development: An African Perspective</h3>
                    <p>Exploring ethical dilemmas in Artificial Intelligence with an African philosophical framework.</p>
                    <div className={styles['pub-meta']}>
                      <span>Tech Ethics Journal</span>
                      <span>2023</span>
                    </div>
                    <a href="#" className={styles['read-more']}>Read Full Article →</a>
                  </div>
                </div>
                
                <div className={styles['publication-card']}>
                  <div className={styles['pub-image']} style={{ backgroundImage: "url('https://images.unsplash.com/photo-1460518451285-97b6aa326961?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80')" }}></div>
                  <div className={styles['pub-content']}>
                    <div className={styles['pub-type']}>Journal Article</div>
                    <h3>Interrogating Cultural Relativism in Human Rights</h3>
                    <p>A critical examination of cultural relativism's role in international human rights discourse.</p>
                    <div className={styles['pub-meta']}>
                      <span>Global Ethics Review</span>
                      <span>2021</span>
                    </div>
                    <a href="#" className={styles['read-more']}>Read Full Article →</a>
                  </div>
                </div>
              </div>
              <div className={styles['publications-all-button-container']}>
                <button className={styles['philo-view-all-button']}>View all 20+ publications</button>
              </div>
            </section>
            
            {/* Additional Publications */}
            <section id="additional-publications" className={styles['additional-publications']}>
              <h2 className={styles['section-title']}>More Publications</h2>
              <div className={styles['pub-grid']}>
                <div className={styles['pub-item']}>
                  <div className={styles['pub-image']} style={{ backgroundImage: "url('https://images.unsplash.com/photo-1589652717521-10c0d092dea9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80')" }}></div>
                  <div className={styles['pub-details']}>
                    <div className={styles['pub-type']}>Book</div>
                    <h3>Logic in Traditional African Thought</h3>
                    <a href="#" className={styles['read-more']}>Read →</a>
                  </div>
                </div>
                <div className={styles['pub-item']}>
                  <div className={styles['pub-image']} style={{ backgroundImage: "url('https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80')" }}></div>
                  <div className={styles['pub-details']}>
                    <div className={styles['pub-type']}>Article</div>
                    <h3>Feminist Philosophy: A Decolonial Critique</h3>
                    <a href="#" className={styles['read-more']}>Read →</a>
                  </div>
                </div>
                <div className={styles['pub-item']}>
                  <div className={styles['pub-image']} style={{ backgroundImage: "url('https://images.unsplash.com/photo-1581094794329-16b125e1d71e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80')" }}></div>
                  <div className={styles['pub-details']}>
                    <div className={styles['pub-type']}>Paper</div>
                    <h3>Ethical Leadership in Public Administration</h3>
                    <a href="#" className={styles['read-more']}>Read →</a>
                  </div>
                </div>
                <div className={styles['pub-item']}>
                  <div className={styles['pub-image']} style={{ backgroundImage: "url('https://images.unsplash.com/photo-1541339907198-e08756dedf3f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80')" }}></div>
                  <div className={styles['pub-details']}>
                    <div className={styles['pub-type']}>Book</div>
                    <h3>African Philosophy in the Digital Age</h3>
                    <a href="#" className={styles['read-more']}>Read →</a>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </main>
    </div>
  );
};

export default StaffProfile;